import React from "react";
import themes from "../../themes";
import NavStyled from "./NavStyled";
import RoundButton from "../../components/RoundButton";
import { Route, Link } from "react-router-dom";

const Nav = props => {
  const color = props.theme === "dark" ? themes[0].text : themes[1].text;
  return (
    <NavStyled theme={props.theme} id="nav">
      <Link to="/" style={{ textDecoration: "none" }}>
        <Route
          path="/:book/:chapter/:section"
          render={() => (
            <i
              className="material-icons"
              style={{
                color: color,
                position: "absolute",
                top: "22px",
                left: "25px",
                fontSize: 36
              }}
            >
              apps
            </i>
          )}
        />
      </Link>
      <RoundButton
        style={{
          position: "absolute",
          right: "7px",
          bottom: "40px"
        }}
        theme={props.theme}
        onClick={() => props.setTheme()}
      >
        Theme
      </RoundButton>
    </NavStyled>
  );
};

export default Nav;



// WEBPACK FOOTER //
// ./src/containers/nav/Nav.js